module.exports = "../../app/cells/components/trial/top_bar/expired_cell.rb";